export default __webpack_public_path__ + "static/media/pedroh.32803b33.png";